<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input v-model="search.name" placeholder="序列号" class="filter-item" style="width: 300px;" @keyup.enter.native="handleFilter"/>
      <el-select v-model="search.status" placeholder="状态" class="filter-item" style="width: 130px" clearable>
        <el-option v-for="item in option.status" :key="item.key" :label="item.val" :value="item.key"/>
      </el-select>
      <el-button v-waves type="primary" class="filter-item" icon="el-icon-search" @click="handleFilter">查询</el-button>
      <el-button type="primary" class="filter-item" style="margin-left: 10px;" icon="el-icon-edit" @click="handleCreate">添加</el-button>
    </div>

    <el-table v-loading="listLoading" :key="tableKey" :data="list" border fit highlight-current-row style="width: 100%;">
      <el-table-column label="序列号" prop="sn" align="center" width="200px"></el-table-column>
      <el-table-column label="名称" prop="name"></el-table-column>
      <el-table-column label="品牌" prop="brand"></el-table-column>
      <el-table-column label="货号" prop="no" align="center" width="120px"></el-table-column>
      <el-table-column label="内部编号" prop="inno" align="center" width="120px"></el-table-column>
      <el-table-column label="填料" prop="filler" align="center" width="120px"></el-table-column>
      <el-table-column label="理论塔板数" prop="plate" align="center" width="120px"></el-table-column>
      <el-table-column label="柱内径" align="center" width="120px">
        <template slot-scope="scope">
          <span>{{ scope.row.calibre }}mm</span>
        </template>
      </el-table-column>
      <el-table-column label="柱长" align="center" width="80px">
        <template slot-scope="scope">
          <span>{{ scope.row.len }}mm</span>
        </template>
      </el-table-column>
      <el-table-column label="填料孔径" align="center" width="80px">
        <template slot-scope="scope">
          <span>{{ scope.row.bore }}Å</span>
        </template>
      </el-table-column>
      <el-table-column label="填料粒径" align="center" width="120px">
        <template slot-scope="scope">
          <span>{{ scope.row.grain }}um</span>
        </template>
      </el-table-column>
      <el-table-column label="柱死体积" align="center" width="120px">
        <template slot-scope="scope">
          <span>{{ scope.row.die }}ml</span>
        </template>
      </el-table-column>
      <el-table-column label="启用时间" align="center" width="120px">
        <template slot-scope="scope">
          <span>{{ scope.row.start }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center" width="100px">
        <template slot-scope="scope">
          <span>{{ scope.row.status | statusFilter }}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" width="150" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-tooltip content="编辑" class="item" effect="dark" placement="bottom">
            <el-button type="text" class="btn-text" @click="handleEdit(scope.row)">
              <svg-icon icon-class="edit"/>
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container right">
      <el-pagination v-show="total > search.size" :current-page="search.page" :page-size="search.size" :total="total" layout="total, prev, pager, next" @current-change="handleCurrentChange"/>
    </div>

    <el-dialog class="dia" :title="!temp.id? '添加': '编辑'" :visible.sync="dia.edit" top="1vh">
      <el-form ref="dataForm" :rules="rules" :model="temp" label-position="left" label-width="120px" style="max-width: 400px; margin-left:50px;">
        <el-form-item label="序列号" prop="sn">
          <el-input v-model="temp.sn" placeholder="请填写序列号，添加后不可修改" v-if="!temp.id" />
          <span v-else>{{ temp.sn }}</span>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="temp.name" placeholder="请填写名称"/>
        </el-form-item>
        <el-form-item label="品牌" prop="brand">
          <el-input v-model="temp.brand" placeholder="请填写品牌"/>
        </el-form-item>
        <el-form-item label="货号" prop="no">
          <el-input v-model="temp.no" placeholder="请填写货号"/>
        </el-form-item>
        <el-form-item label="内部编号" prop="inno">
          <el-input v-model="temp.inno" placeholder="请填写内部编号"/>
        </el-form-item>
        <el-form-item label="填料" prop="filler">
          <el-input v-model="temp.filler" placeholder="请填写填料"/>
        </el-form-item>
        <el-form-item label="理论塔板数" prop="plate">
          <el-input v-model="temp.plate" placeholder="请填写理论塔板数"/>
        </el-form-item>
        <el-form-item label="柱内径" prop="calibre">
          <el-input v-model="temp.calibre" placeholder="请填写柱内径">
            <template slot="append">mm</template>
          </el-input>
        </el-form-item>
        <el-form-item label="柱长" prop="len">
          <el-input v-model="temp.len" placeholder="请填写柱长">
            <template slot="append">mm</template>
          </el-input>
        </el-form-item>
        <el-form-item label="填料孔径" prop="bore">
          <el-input v-model="temp.bore" placeholder="请填写填料孔径">
            <template slot="append">Å</template>
          </el-input>
        </el-form-item>
        <el-form-item label="填料粒径" prop="grain">
          <el-input v-model="temp.grain" placeholder="请填写填料粒径">
            <template slot="append">um</template>
          </el-input>
        </el-form-item>
        <el-form-item label="柱死体积" prop="die">
          <el-input v-model="temp.die" placeholder="请填写柱死体积">
            <template slot="append">ml</template>
          </el-input>
        </el-form-item>
        <el-form-item label="启用时间" prop="start">
          <el-date-picker v-model="temp.start" type="date" placeholder="选择日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio v-model="temp.status" v-for="(row, idx) in option.status" :key="idx" :label="row.key">{{ row.val }}</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dia.edit = false">取消</el-button>
        <el-button type="primary" @click="saveData">确定</el-button>
      </div>
    </el-dialog>
    <!-- edit -->

  </div>
</template>

<script>
import waves from '@/directive/waves'

const option = {
  status: [{key: '1', val: '可用'}, {key: '0', val: '停用'}]
}

export default {
  name: 'AdminSpectrum',
  directives: {
    waves
  },
  filters: {
    statusFilter(key) {
      let data = option.status.find(row => row.key == key)
      return data.val || '-'
    }
  },
  data() {
    return {
      tableKey: 0,
      list: [],
      total: 0,
      listLoading: true,
      search: {
        page: 1,
        size: 12,
        name: '',
        status: ''
      },
      option: option,
      user: [],
      dia: {
        edit: false
      },
      temp: {},

      rules: {
        sn: [{ required: true, message: '请填写序列号', trigger: 'blur' }],
        name: [{ required: true, message: '请填写名称', trigger: 'blur' }],
        brand: [{ required: true, message: '请填写品牌', trigger: 'blur' }],
        no: [{ required: true, message: '请填写货号', trigger: 'blur' }],
        inno: [{ required: true, message: '请填写内部编号', trigger: 'blur' }],
        filler: [{ required: true, message: '请填写填料', trigger: 'blur' }],
        plate: [{ required: true, message: '请填写理论塔板数', trigger: 'blur' }],
        calibre: [{ required: true, message: '请填写柱内径', trigger: 'blur' }],
        len: [{ required: true, message: '请填写柱长', trigger: 'blur' }],
        bore: [{ required: true, message: '请填写填料孔径', trigger: 'blur' }],
        grain: [{ required: true, message: '请填写填料粒径', trigger: 'blur' }],
        die: [{ required: true, message: '请填写柱死体积', trigger: 'blur' }],
        start: [{ required: true, message: '请选择项目开始时间', trigger: 'change' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      const _t = this
      _t.listLoading = true
      _t.$http.post('/api/spectrum/', _t.search).then(resp => {
        _t.list = resp.data.list
        _t.total = resp.data.total
        setTimeout(() => {
          _t.listLoading = false
        }, 500)
      }).catch(() => {
        setTimeout(() => {
          _t.listLoading = false
        }, 500)
      })
    },
    handleFilter() {
      this.search.page = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.search.page = val
      this.getList()
    },
    handleCreate() {
      this.temp = {}
      this.dia.edit = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleEdit(row) {
      this.temp = Object.assign({}, row)
      this.dia.edit = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    saveData() {
      const _t = this
      _t.$refs['dataForm'].validate((valid) => {
        if (valid) {
          _t.$http.post('/api/spectrum/save', _t.temp).then(function(resp) {
            if (resp.code === 0) {
              _t.$message.success(resp.msg)
              _t.dia.edit = false
              _t.getList()
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dia {
  .tip {
    color: $dark;
    font-size: 12px;
  }
}
</style>

